import React, { useEffect, useState, useRef } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Button, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { useLocation, useNavigate } from 'react-router-dom';
import { CreatePVLogs, getPV_planbyId, getLogByPlanId } from '../../ReduxStore/CreatePlanSlice';
import { getAssetDataByVendorCode } from '../../ReduxStore/VendorDataSlice';
import { BarcodeScanner } from '../QRCodeScanner';
import Papa from 'papaparse';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const VendorWithAssets = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Physical Verification', href: '/physical-verification' },
    ];
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const vendorCode = pathname[4];
    const plan_id = pathname[5];
    const formattedDate = pathname[6];

    const fileInputRef = useRef(null);
    const [showAssetList, setShowAssetList] = useState(true);
    const [showMatchedAsset, setShowMatchedAsset] = useState(false);
    const [showAssets, setShowAssets] = useState(true);
    const [jsonData, setJsonData] = useState(null);
    const [showScanner, setShowScanner] = useState(false);
    const [assetList, setAssetList] = useState('');
    const [Plan, setPlan] = useState('');
    const [highlightedAssets, setHighlightedAssets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rfidNo, setRfidNo] = useState("");
    const [defaultCheckpoints, setDefaultCheckpoints] = useState([]);
    const [MatcedAssets, setMatcedAssets] = useState([]);
    const [pvDoneAssetIds, setPVDoneAssetIds] = useState([]);
    const [doneBy, setDoneBy] = useState("");
    const [GoogleMapsUrl, setGoogleMapsUrl] = useState();
    // const [formattedDate, setFormattedDate] = useState()


    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            Papa.parse(file, {
                complete: (result) => {
                    const json = result.data.map((row, rowIndex) => {
                        return rowIndex === 0
                            ? null
                            : Object.fromEntries(row.map((cell, index) => [result.data[0][index], cell]));
                    }).filter(row => row !== null);
                    setJsonData(json);
                    // console.log("JSON Data from file", json)
                    // Extract "Asset" values and set to assetList
                    // const assetNoList = json.map(item => item["Asset       "].trim());
                    const assetNoList = json.map(item => item["Asset No"].trim());
                    // console.log("assetNoList from CSV File", assetNoList)

                    const matchedAssets = assetList.filter(assetItem =>
                        assetNoList.includes(assetItem.asset_no.trim())
                    );
                    setMatcedAssets(matchedAssets)
                    console.log("matched", matchedAssets)
                    if (matchedAssets.length > 0) {
                        toast.success(`${matchedAssets.length} assets are matched`)
                        setShowAssets(false);
                        setShowMatchedAsset(true);
                    } else {
                        toast.info("No Asset matched!")
                    }
                    matchedAssets.map(item => setHighlightedAssets(prevState => [...prevState, item.asset_no]));
                    // setHighlightedAssets(matchedAssets.asset_no);
                    // console.log("highlight", highlightedAssets)

                },
                header: false
            });
        }
    };


    const getlogs = async () => {
        try {
            const action = dispatch(getLogByPlanId(`?plan_id=${plan_id}&plan_date=${formattedDate}`));
            const res = await action.unwrap();
            // console.log("log response:", res);
            setDefaultCheckpoints(res.result.pv_logs);

            // Extract unique asset IDs from pv_logs
            const uniqueAssetIds = Array.from(
                new Set(res.result.pv_logs.map(log => log.asset_id))
            );
            // Set the unique asset IDs to a state variable
            setPVDoneAssetIds(uniqueAssetIds); // Assuming this stores the unique IDs
            // console.log("pvDoneAssetIds", uniqueAssetIds)

        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    };

    const handleDecode = (result) => {
        setRfidNo(result);
        setShowScanner(false);
        console.log("DONE", result)
        // TML/VT/FA82608
        const matchedAsset = assetList.find(asset => asset.rfid_no === result);
        if (matchedAsset) {
            toast.success(`Asset found`);
            navigate(`/physical-verification/checkpoint-verification/${Plan.id}/${matchedAsset.id}/${Plan.supplier_id}/${Plan.start_date}`)
        } else {
            setShowAssetList(true)
            toast.error(`No asset found with the given RFID ${result} `);
        }
    };

    const handleError = (error) => {
        console.error("Error decoding barcode:", error);
    };

    const handleStop = () => {
        setShowScanner(false);
        setShowAssetList(true);
    }


    const OpenQrCodeHandler = () => {
        setShowAssetList(false)
        setShowScanner(true)
    }


    const handler = (asset) => {
        navigate(`/physical-verification/checkpoint-verification/${Plan.id}/${asset.id}/${Plan.supplier_id}/${formattedDate}`)
    }

    const importCSVHandler = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }



    const submitHandler = async () => {
        // const checkpointData = defaultCheckpoints.map(cp => ({
        //     id: cp.checkpoint_id,
        //     ok: true
        // }));
        const checkpointData = Array.from(
            new Map(
                defaultCheckpoints.map(cp => [cp.checkpoint_id, { id: cp.checkpoint_id, ok: true }])
            ).values()
        );
        const supplier_id = Plan.supplier_id

        for (const [index, item] of MatcedAssets.entries()) {
            const log_data = {
                plan_id,
                asset_id: item.id, // Assuming asset_id is a property in item
                supplier_id,
                done_by: doneBy,
                current_location: "",
                current_location_url: GoogleMapsUrl,
                observation: "All Okay",
                checkpoints: checkpointData
            };
            // console.log("PAYLOAD:", log_data);

            try {
                const action = dispatch(CreatePVLogs(log_data));
                const res = await action.unwrap();
                console.log("res from pv log:", res);

                if (res.StatusCode === 201) {
                    toast.success(`Checkpoint Done for asset ${item.asset_no}`);
                } else {
                    toast.error(`Something went wrong for asset ${item.asset_no}`);
                }
            } catch (error) {
                toast.error(`Error for asset ${item.asset_no}: ${error.message}`);
            }
            // Check if this is the last iteration
            if (index === MatcedAssets.length - 1) {
                setShowAssets(true);
                setShowMatchedAsset(false);
                getlogs();
                setDoneBy("")
            }
        }
    };

    // const submitHandler = async () => {
    //     MatcedAssets.map(item=>item)
    //     const checkpointData = defaultCheckpoints.map(cp => ({
    //         id: cp.checkpoint_id,
    //         ok: true
    //     }));
    //     // const log_data = {
    //     //     plan_id,
    //     //     asset_id,
    //     //     supplier_id,
    //     //     done_by: doneBy,
    //     //     current_location: "pune",
    //     //     observation,
    //     //     checkpoints: checkpointData
    //     // };
    //     // console.log("PAYLOAD:", log_data);
    //     // const action = dispatch(CreatePVLogs(log_data));
    //     // const res = await action.unwrap();
    //     // console.log("res from pv log:", res);
    //     // if (res.StatusCode === 201) {
    //     //     toast.success("Checkpoint Done");
    //     // } else {
    //     //     toast.error("Something went wrong!")
    //     // }
    // };


    const getAssetListforVendor = async () => {
        try {
            const action = dispatch(getAssetDataByVendorCode(vendorCode));
            const res = await action.unwrap();
            // console.log("Asset List for vendor", res);
            // setAssetList(res.result);
            // Remove hyphens from the 'id' field in each asset object
            const modifiedAssets = res.result.map(asset => ({
                ...asset,
                id: asset.id.replace(/-/g, ""), // Remove hyphens from the id
                asset_no: (asset.asset_no)?.slice(3)
            }));

            // console.log("Asset List for vendor", modifiedAssets);
            setAssetList(modifiedAssets);
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    }

    const getPlanById = async () => {
        try {
            const action = dispatch(getPV_planbyId(plan_id));
            const res = await action.unwrap();
            // console.log("plan from plan id", res.result.PV_plan[0]);
            setPlan(res.result.PV_plan[0]);
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    }

    const getLocation = async () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;

                // console.log("Location", latitude, longitude);

                // // Set the location state
                // setLocation({
                //     latitude: latitude,
                //     longitude: longitude
                // });

                // Generate the Google Maps URL
                const googleMapsUrl = `https://maps.google.com/?q=${latitude},${longitude}`;
                // console.log("Google Maps URL:", googleMapsUrl);
                setGoogleMapsUrl(googleMapsUrl)
            });
        } else {
            console.error("Geolocation is not supported by this browser.");
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            await getLocation();
            await getPlanById();
            await getAssetListforVendor();
            await getlogs();
            setLoading(false);
        };
        fetchData();
    }, [])

    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {showAssetList && <>
                    <Box mt={1}>
                        <Typography variant="h5" component="h1" gutterBottom>
                            {Plan.vendor_details.vendor_group}-{Plan.vendor_details.vendor}
                        </Typography>
                    </Box>
                    <Box mt={2} mb={2}>
                        <CustomBreadcrumbs links={breadcrumbsLinks} current="Vendor Details" />
                    </Box>
                    <Box my={3}>
                        <Grid container className='row1' spacing={2}>
                            <Grid item xs={12} sm={8}>
                                <Typography variant="body1" style={{ fontSize: '24px', fontWeight: 300, textTransform: "uppercase" }}>
                                    {/* List of Assets for {Plan.vendor_details.vendor_group} */}
                                    List of Assets
                                </Typography>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={OpenQrCodeHandler}
                                >
                                    Scan QR
                                </Button>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <input
                                    type="file"
                                    accept=".csv"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileUpload}
                                />
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={importCSVHandler}
                                >
                                    Import CSV
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                    {showAssets && <Box>
                        {assetList && assetList.map((item, index) => (
                            <Grid container className="assets" key={index} onClick={() => handler(item)}
                                // style={{
                                //     backgroundColor: highlightedAssets.includes(item.asset) ? 'yellow' : 'inherit',
                                //     color: highlightedAssets.includes(item.asset) ? 'white' : 'inherit'
                                // }}
                                style={{
                                    backgroundColor: pvDoneAssetIds.includes(item.id) ? "green" : "transparent",
                                    color: pvDoneAssetIds.includes(item.id) ? "white" : "black"
                                }}
                            // style={{
                            //     backgroundColor: pvDoneAssetIds?.includes(item.id)
                            //         ? "green"
                            //         : highlightedAssets?.includes(item.asset_no)
                            //             // ? "yellow"
                            //             ? "#FFDB58" // Mustard color
                            //             : "transparent",
                            //     color: pvDoneAssetIds?.includes(item.id)
                            //         ? "white"
                            //         : "black"
                            // }}
                            >
                                <Grid item xs={12} sm={2}>
                                    <h4>Asset No: {item.asset_no} </h4>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <h4>Asset Description: {item.description} </h4>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <h4>RFID No: {item?.rfid_no || "NA"} </h4>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <h4>Part No: {item?.material_no || "NA"} </h4>
                                </Grid>
                            </Grid>

                        ))}
                    </Box>}
                    {showMatchedAsset && <Box>
                        {MatcedAssets && MatcedAssets.map((item, index) => (
                            <Grid container className="assets" key={index} onClick={() => handler(item)}
                                // style={{
                                //     backgroundColor: "#FFDB58",
                                //     color: "black"
                                // }}
                                style={{
                                    backgroundColor: pvDoneAssetIds?.includes(item.id)
                                        ? "green"
                                        : highlightedAssets?.includes(item.asset_no)
                                            // ? "yellow"
                                            ? "#FFBF00" // Mustard color
                                            : "transparent",
                                    color: pvDoneAssetIds?.includes(item.id)
                                        ? "white"
                                        : "black"
                                }}
                            >
                                <Grid item xs={12} sm={2}>
                                    <h4>Asset No: {item.asset_no}</h4>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <h4>Asset Description: {item.description} </h4>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <h4>RFID No: {item?.rfid_no || "NA"} </h4>
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <h4>Part No: {item?.material_no || "NA"} </h4>
                                </Grid>
                            </Grid>

                        ))}
                    </Box>}
                    <Box my={3}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={4}>
                                <TextField
                                    label="Carried out by"
                                    name="transferDate"
                                    type="text"
                                    variant="outlined"
                                    fullWidth
                                    value={doneBy}
                                    onChange={(e) => setDoneBy(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    size='large'
                                    fullWidth
                                    onClick={submitHandler}
                                >
                                    Submit
                                </Button>
                            </Grid>

                        </Grid>
                    </Box>
                </>}

                {showScanner && (
                    <>
                        <Box>
                            <Typography variant="h4" component="h1" gutterBottom>
                                Scan RFID TAG
                            </Typography>
                        </Box>
                        <Box className='checkpoint-box'>
                            <BarcodeScanner handleDecode={handleDecode} handleError={handleError} handleStop={handleStop} />
                            <Grid container justifyContent="center" alignItems="center">
                                <Grid item xs={12} sm={2}>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleStop}
                                    >
                                        Stop Scan
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                )}
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default VendorWithAssets;
